// removed by extract-text-webpack-plugin
module.exports = {"grey":"#707070","medium-grey":"#9f9f9f","black":"#000000","large":"1600px","container":"_38sig_u5yqHMNktQoC1sJy","sectionHead":"_3QuXuotoLxTJ9eVAwuPITX","title":"_2bse23HLRsldw03G7nK-Yf","sectionList":"_3nCC_ZNfQw4ddW0lLNyALY","sectionItem":"_3aI8w5ghL20r7HiOVHOcPn","sectionName":"_2hABsGW-Giz3HIC7H-LKu4","landing":"_5c8jTthQnXLXZIA1GCgpV","logo":"_16zzrgRj4N7a7rtiggj2n","carousel":"_3huOrzPkf3QO63zCrzx3-y"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/VerticalSectionMarker/VerticalSectionMarker.css
// module id = 1350
// module chunks = 0